import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../../theme/helpers/fontStyle';

export const $DocumentWrapper = styled.div`
  border: 1px solid #c9ced6;
  padding: ${spacing('lg')};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  flex: 1;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  ${fontStyle('lg')};
  font-weight: ${fontWeight('medium')};
  display: flex;
  align-items: center;
`;

export const $DocumentIcon = styled.div`
  width: ${spacing('xxl')};
  height: ${spacing('xxl')};
  margin-right: ${spacing('lg')};

  && svg {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const $DocumentName = styled.div`
  display: block;
  flex: 1;
  margin-right: ${spacing(5)};
  ${fontStyle('base')};
`;
